import { render, staticRenderFns } from "./reportMerchant4Admin.vue?vue&type=template&id=8c58b160&scoped=true"
import script from "./reportMerchant4Admin.vue?vue&type=script&lang=js"
export * from "./reportMerchant4Admin.vue?vue&type=script&lang=js"
import style0 from "./reportMerchant4Admin.vue?vue&type=style&index=0&id=8c58b160&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c58b160",
  null
  
)

export default component.exports